import { render } from "./PropertyBwof.vue?vue&type=template&id=39a393ac&ts=true"
import script from "./PropertyBwof.vue?vue&type=script&lang=ts"
export * from "./PropertyBwof.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__